@let itemLabel = label();
@let userData = user();

<div class="form-field" [class.centered]="isCentered()">
    @if (itemLabel) {
        <form-label
            [id]="'user-label'"
            [forId]="'user-info'"
            [label]="itemLabel | translate"
            [minWidth]="'150px'"></form-label>
    }

    @if (userData) {
        <div class="user-info">
            <div ellipsis-tooltip class="user-name" [id]="'user-name-' + userData.id">
                {{ userData.fullName }}
            </div>

            @if (userData.email) {
                <div ellipsis-tooltip class="user-email" [id]="'user-email-' + userData.id">
                    {{ userData.email }}
                </div>
            }
        </div>
    } @else {
        -
    }
</div>
